import React from 'react';
import { observer } from 'mobx-react';
import type CreateShipmentQuoteAppManager from 'apps/shipmentQuote/appManager';
import { PriceBreakdown } from 'apps/shared';

export const CostList = observer(
  ({
    shipmentQuoteAppManager,
  }: {
    shipmentQuoteAppManager: CreateShipmentQuoteAppManager;
  }) => {
    const { shipmentQuoteApp } = shipmentQuoteAppManager;
    const { shippingQuote } = shipmentQuoteApp;

    const productionCosts = shipmentQuoteAppManager.productQuoteApps.reduce(
      (acc: number, pq: any) => acc + pq.cost,
      0,
    );

    const miscItemsTotalCost = shipmentQuoteApp.miscItems.reduce(
      (acc: number, miscItem: any) =>
        acc + miscItem.cost * (1 - miscItem.discount / 100),
      0,
    );

    const { takeRate } = shipmentQuoteAppManager.shipmentQuoteApp;
    const takeRateAmount =
      ((takeRate / 100) * productionCosts) / (1 - takeRate / 100);

    return (
      <PriceBreakdown
        currency={shipmentQuoteApp.currency || 'EUR'}
        productionCosts={productionCosts}
        shippingCosts={shippingQuote.cost}
        shippingDiscount={shippingQuote.discount}
        miscItemsTotalCost={miscItemsTotalCost}
        takeRate={takeRate}
        takeRateAmount={takeRateAmount}
        totalCost={null}
      />
    );
  },
);
